import React from 'react';
import { useSelector } from 'src/store';
import { RootState } from 'src/store';
import AccordionSection from './Common/AccordionSection';
import { DownloadExampleFiles } from './Common/DownloadExampleFiles';
import { AbnormalityFilter } from './Settings/AbnormalityFilter';
import { AbnormalityStains } from './Settings/AbnormalityStains';
import { BandsFileUpload } from './Settings/BandsFileUpload';
import { BandStains } from './Settings/BandStains';
import { ChromosomeFilter } from './Settings/ChromosomeFilter';
import { DownloadFormats } from './Settings/DownloadFormats';
import { GenesFileUpload } from './Settings/GenesFileUpload';
import { HideUnusedAbnormalityTypesCheckBox } from './Settings/HideUnusedAbnormalityTypesCheckBox';
import { LayoutSelector } from './Settings/LayoutSelector';
import { PreviewCheckBox } from './Settings/PreviewCheckbox';
import { RenderButton } from './Settings/RenderButton';
import { SampleFileUpload } from './Settings/SampleFileUpload';
import { TranslocationFileUpload } from './Settings/TranslocationFileUpload';

export const SidePanelLeft = () => {
  const renderLayout = useSelector((state: RootState) => state.buildRenderRequest.renderLayout);
  const isCircular = renderLayout === 'Circular';

  return (
    <div className="sidebar-inner">
      <AccordionSection icon="↑" title="Files" badge="Required" defaultOpen={true}>
        <span className="field-label">Cytoband File</span>
        <BandsFileUpload />
        <span className="field-label" style={{ marginTop: 12, display: 'block' }}>
          Sample File
          <span
            className="info-icon"
            style={{ marginLeft: 6 }}
            title="Tab-delimited (.txt/.tsv) with columns: patientid, chromosome, type, start, end. Also accepts a Wakhan CNA VCF (.vcf) for copy-number segments."
          >
            i
          </span>
        </span>
        <SampleFileUpload />
        <span className="field-label" style={{ marginTop: 12, display: 'block' }}>Genes File</span>
        <GenesFileUpload />
        {isCircular && <TranslocationFileUpload />}
        <DownloadExampleFiles />
      </AccordionSection>

      <AccordionSection icon="⚙" title="Options" badge="Optional" defaultOpen={true}>
        <LayoutSelector />
        <PreviewCheckBox />
        <HideUnusedAbnormalityTypesCheckBox />
      </AccordionSection>

      <AccordionSection icon="▣" title="File Format" badge="Optional" defaultOpen={false}>
        <DownloadFormats />
      </AccordionSection>

      <AccordionSection icon="◉" title="Abnormality Colors" badge="Optional" defaultOpen={false}>
        <AbnormalityStains />
      </AccordionSection>

      <AccordionSection icon="▬" title="Band Stain Colors" badge="Optional" defaultOpen={false}>
        <BandStains />
      </AccordionSection>

      <AccordionSection icon="≡" title="Chromosome Filter" badge="Optional" defaultOpen={false}>
        <ChromosomeFilter />
      </AccordionSection>

      <AccordionSection icon="⊟" title="Abnormality Filter" badge="Optional" defaultOpen={false}>
        <AbnormalityFilter />
      </AccordionSection>

      <div className="generate-wrap">
        <RenderButton />
      </div>
    </div>
  );
};
